/**
 * Created by alex on 12.12.2016.
 */

import Action, {
  SET_GENERIC_APP_ERROR,
  CLEAR_GENERIC_APP_ERROR,
} from 'constants/action-types'

/**
 * Generic errors
 */
export default (
  state: GenericError | null = null,
  action: Action,
): GenericError | null => {
  switch (action.type) {
    case SET_GENERIC_APP_ERROR:
      return action.payload
    case CLEAR_GENERIC_APP_ERROR:
      return null
    default:
      return state
  }
}
